import React from 'react';
import PropTypes from 'prop-types';
import { i18next, utils, dialogs } from '@yola/ws-sdk';
import { AlertDialog } from '@yola/ws-ui';
import useCustomerSupport from 'yola-editor/src/js/modules/common/hooks/use-customer-support';

function TranslationGuidelinesErrorDialog({ onDismiss = utils.noop }) {
  const { onContactSupport, isCustomerSupportAvailable } = useCustomerSupport();

  const handleDismiss = () => {
    dialogs.operations.hide();
    onDismiss();
  };

  const handleSubmit = () => {
    dialogs.operations.hide();
    onContactSupport();
  };

  const captions = {
    title: i18next.t('Something went wrong'),
    description: i18next.t(
      'An error occurred while saving your translation guidelines. Please try again later{contactSupport}.',
      {
        contactSupport: isCustomerSupportAvailable ? i18next.t(' or contact customer support') : '',
      }
    ),
    dismiss: i18next.t('Cancel'),
    ...(isCustomerSupportAvailable && { submit: i18next.t('Contact support') }),
  };

  return (
    <AlertDialog
      onDismiss={handleDismiss}
      captions={captions}
      glyph="alert-circle"
      height="auto"
      width={358}
      {...(isCustomerSupportAvailable && { onSubmit: handleSubmit })}
    />
  );
}

TranslationGuidelinesErrorDialog.propTypes = {
  onDismiss: PropTypes.func,
};

export default TranslationGuidelinesErrorDialog;
